
const addAllOption = arr => {
  return [
    {
      value: null,
      str: "All",
    },
    ...arr,
  ]
}

export default {
  computed: {
    sizeOptions() {
      return [
        {
          value: "SMALL",
          str: "Small",
        },
        {
          value: "MEDIUM",
          str: "Medium",
        },
        {
          value: "LARGE",
          str: "Large",
        },
        {
          value: "XLARGE",
          str: "Xlarge",
        },
      ]
    },
    activeOptions() {
      return [
        {
          value: "ACTIVE",
          str: "Active",
        },
        {
          value: "BLOCKED",
          str: "Blocked",
        },
      ]
    },
    roleOptions() {
      return [
        {
          value: "EMPLOYEE",
          str: "Employee",
        },
        {
          value: "MAINTAINER",
          str: "Maintainer",
        },
        {
          value: "ADMIN",
          str: "Admin",
        },
      ]
    },
    taxOptions() {
      return [
        {
          value: "LAAG",
          str: "LAAG",
        },
        {
          value: "HOOG",
          str: "HOOG",
        },
      ]
    },
    translationOptions() {
      return [
        {
          value: "en_EN",
          str: "English (Engels)"
        },
        {
          value: "nl_NL",
          str: "Dutch (Nederlands)",
        },
        {
          value: "fr_FR",
          str: "French (Frans)",
        },
        {
          value: "de_DE",
          str: "German (Duits)",
        },
      ]
    },
    shortLanguageOptions() {
      return [
        {
          value: "DE",
          str: "Duits",
        },
        {
          value: "FR",
          str: "Frans",
        },
        {
          value: "NL",
          str: "Nederlands",
        },
        {
          value: "EN",
          str: "Engels",
        },
      ]
    },
    languageOptions() {
      return [
        {
          value: "de_DE",
          str: "Duits",
        },
        {
          value: "fr_FR",
          str: "Frans",
        },
        {
          value: "nl_NL",
          str: "Nederlands",
        },
        {
          value: "en_EN",
          str: "Engels",
        },
      ]
    },

    taxOptionsAll() {
      return addAllOption(this.taxOptions)
    },
    roleOptionsAll() {
      return addAllOption(this.roleOptions)
    },
    sizeOptionsAll() {
      return addAllOption(this.sizeOptions)
    },
    activeOptionsAll() {
      return addAllOption(this.activeOptions)
    },
  },
}

// roleOptionsAll
